import { httpClientAuth } from './httpClient';
const service = process.env.REACT_APP_API_URL_ATTATCHMENTS;

const getAttachmentSigned = async (body: { url: string }): Promise<any> => {
	return await httpClientAuth(`${service}/attachments/signedurl`, { body });
};

export { getAttachmentSigned };
